import { Icon } from '@/src/tools/icon';
import { get } from 'lodash';
import React from 'react';
import { Menu, MenuItem } from 'src/components/Antd';
import { titleGenerator } from 'src/tools/helper';

import DropDown from 'src/constrains/DropdownHOC';
import css from './css.module.less';

const MultiLangDropDown = (props) => {
  const { options, selected, onDropDownChange, handleOnConfirm } = props;

  return (
    <div className={css.container}>
      <Menu
        onSelect={(e) => {
          handleOnConfirm(e.key);
          onDropDownChange(false);
        }}
        selectedKeys={selected}>
        {options.map((menu) => {
          const { value, label, hasError } = menu || {};
          return (
            <MenuItem
              className={css.subMenu}
              key={value}
              data-tester-title={titleGenerator(label)}>
              <React.Fragment>
                {label}
                {hasError && (
                  <Icon type='iconinfo1' className={css.errIconOption} />
                )}
              </React.Fragment>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
const MultiLangDropDownTrigger = (props: any) => {
  const { className, title, titleHasError } = props;

  return (
    <div className={`${css.mldContainer} ${className}`}>
      <div className={css.titleContainer}>
        <div className={css.nameContainer}>
          <div className={css.title}>{title}</div>
          <Icon type='icondown' className={css.iconDown} />
        </div>

        {titleHasError && (
          <Icon type='iconinfo1' className={css.errIconTitle} />
        )}
      </div>
    </div>
  );
};

const _Switcher = DropDown(MultiLangDropDownTrigger, MultiLangDropDown);

// let exp = {
//   moduleStyle: {
//     title: 'Module Style',
//     hasError: false,
//     child: <div />,
//
//   },
// };

const Switcher = (props) => {
  const { selected, onChange, allSections, selectContainer } = props;
  const options = Object.keys(allSections || {}).map((k) => {
    const obj = allSections[k];
    const { title, hasError } = obj;
    return { label: title, value: k, hasError };
  });
  const hasError = Object.values(allSections || {}).find((v) =>
    get(v, 'hasError'),
  );
  const title = get(allSections[selected], 'title');
  const child = get(allSections[selected], 'child');
  const isSingle = Object.keys(allSections || {}).length < 2;

  return (
    <React.Fragment>
      <div className={`${css.container} ${selectContainer || ''}`}>
        <_Switcher
          //triggerContainer={css.triggerContainer}
          //warningBeforeSwitch={hasModified}
          options={options}
          titleHasError={hasError}
          title={title}
          selected={selected}
          isSingle={isSingle}
          dropdownProps={{
            maxWidth: 300,
            maxHeight: 500,
            triggerContainer: css.triggerContainer,
          }}
          handleOnConfirm={onChange}
          //   isPrimary={isPrimary}
        />
      </div>
      <div className={css.childContainer}>{child}</div>
    </React.Fragment>
  );
};
export default Switcher;
